import type { UserGroupsTranslations } from '@/Pages/Groups/types/groupsTranslations.types';

const enUS: UserGroupsTranslations = {
  title: 'Create Group',
  description: 'Parameterize the necessary information for the group.',
  editTitle: 'Edit group',
  detailsTitle: 'Group details',
  editDescription: 'Check the information filled out below and change it if necessary.',
  cancelAssignmentsButton: 'Cancel group assignment',
  timeline: {
    stepOne: {
      title: 'Group data',
      groupName: {
        label: 'Group Name',
        placeholder: 'Enter the name of your group',
        helperText:
          'Required field. The chosen name must be unique and different from any other already in the system. This ensures organization and prevents information conflicts.',
        errors: {
          required: 'Group name is required',
          alreadyExists: 'This group name already exists',
        },
      },
      groupDescription: {
        label: 'Description',
        placeholder: 'Enter details of the group',
        helperText: 'Optional field to provide more details about the group.',
      },
    },
    stepTwo: {
      title: 'Users',
    },
    permissions: {
      title: 'Permissions',
      administrators: 'Administrator',
      viewers: 'View only',
    },
  },
  transferList: {
    tabs: {
      availables: 'Available',
      assigned: 'Assigned',
    },
    search: {
      placeholder: 'Search for user name',
    },
    saveButton: 'Save changes',
    emptyState: {
      left: {
        title: 'No users available',
      },
      right: {
        title: 'No users assigned',
        description: 'Assign one or more users to this group',
      },
    },
  },
};

export { enUS };
